import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  class: "row",
  id: "training-session-page"
}
const _hoisted_3 = { class: "col-12 card" }
const _hoisted_4 = { class: "row mx-2 my-5" }
const _hoisted_5 = { class: "col-sm-12 col-md-4 order-md-last" }
const _hoisted_6 = { class: "text-center mx-auto mb-0 w-75" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { class: "text-center mb-4" }
const _hoisted_11 = { class: "text-secondary" }
const _hoisted_12 = { class: "text-primary" }
const _hoisted_13 = { class: "text-center" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { key: 2 }
const _hoisted_17 = { key: 3 }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "col-12" }
const _hoisted_22 = {
  key: 0,
  class: "alert alert-danger"
}
const _hoisted_23 = { key: 2 }
const _hoisted_24 = { class: "mb-4" }
const _hoisted_25 = {
  key: 0,
  class: "alert alert-danger mt-3"
}
const _hoisted_26 = { key: 3 }
const _hoisted_27 = {
  key: 0,
  class: "d-inline"
}
const _hoisted_28 = {
  key: 1,
  class: "d-inline"
}
const _hoisted_29 = {
  key: 2,
  class: "d-inline"
}
const _hoisted_30 = { key: 3 }
const _hoisted_31 = {
  key: 0,
  class: "text-center"
}
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { key: 1 }
const _hoisted_34 = {
  key: 4,
  class: "d-inline"
}
const _hoisted_35 = ["href"]
const _hoisted_36 = {
  key: 7,
  class: "text-muted small mt-1"
}
const _hoisted_37 = { class: "text-center bg-light p-4 mb-4" }
const _hoisted_38 = { class: "mb-0" }
const _hoisted_39 = { class: "mb-5" }
const _hoisted_40 = { class: "text-muted" }
const _hoisted_41 = { key: 0 }
const _hoisted_42 = { class: "mb-0" }
const _hoisted_43 = { class: "text-muted" }
const _hoisted_44 = { key: 4 }
const _hoisted_45 = { key: 1 }
const _hoisted_46 = { class: "mb-0" }
const _hoisted_47 = { class: "text-muted" }
const _hoisted_48 = ["onClick"]
const _hoisted_49 = { class: "ts-users-select pt-2" }
const _hoisted_50 = { key: 0 }
const _hoisted_51 = { class: "checkbox-custom ts-user-select w-100 px-4 pt-2 cursor-pointer" }
const _hoisted_52 = ["value"]
const _hoisted_53 = { class: "ts-user-content overflow-hidden" }
const _hoisted_54 = ["src"]
const _hoisted_55 = { key: 0 }
const _hoisted_56 = { key: 1 }
const _hoisted_57 = { key: 2 }
const _hoisted_58 = { key: 1 }
const _hoisted_59 = {
  key: 0,
  class: "alert alert-danger mt-3"
}
const _hoisted_60 = { class: "col-sm-12 col-md-8" }
const _hoisted_61 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_schedule_form = _resolveComponent("schedule-form")!
  const _component_modal = _resolveComponent("modal")!
  const _component_join_links = _resolveComponent("join-links")!
  const _component_scenario_card = _resolveComponent("scenario-card")!
  const _component_training_card = _resolveComponent("training-card")!
  const _component_loading = _resolveComponent("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.loading && typeof(_ctx.training_session) !== 'undefined')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("h4", _hoisted_6, [
                    (!_ctx.training_session.is_complete && !_ctx.training_session.is_canceled)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_7, "This training session is scheduled for:"))
                      : (_ctx.training_session.is_canceled)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_8, "This training session was scheduled for:"))
                        : (_ctx.training_session.is_complete)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_9, "This training session occurred on:"))
                          : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("h4", _hoisted_10, [
                    _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.moment(_ctx.training_session.utc_time || _ctx.training_session.local_time).format('MM/DD/YY')), 1),
                    _cache[23] || (_cache[23] = _createTextVNode()),
                    _cache[24] || (_cache[24] = _createElementVNode("small", null, "at", -1)),
                    _cache[25] || (_cache[25] = _createTextVNode()),
                    _createElementVNode("span", _hoisted_12, [
                      _createTextVNode(_toDisplayString(_ctx.moment(_ctx.training_session.utc_time || _ctx.training_session.local_time).format('h:mm')), 1),
                      _createElementVNode("sup", null, _toDisplayString(_ctx.moment(_ctx.training_session.utc_time || _ctx.training_session.local_time).format('a')), 1)
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_13, [
                    _createElementVNode("small", null, [
                      _cache[26] || (_cache[26] = _createTextVNode(" Duration ")),
                      (_ctx.training_session.training_session_type_id == _ctx.TrainingSessionType.SCENARIO)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_14, "2 hours"))
                        : (_ctx.training_session.training_session_type_id == _ctx.TrainingSessionType.ONBOARDING)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_15, "1 hour"))
                          : (_ctx.training_session.training_session_type_id == _ctx.TrainingSessionType.GROUPED)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_16, "3 hours"))
                            : (_ctx.training_session.training_session_type_id == _ctx.TrainingSessionType.LARGEGROUP)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_17, "4 hours"))
                              : _createCommentVNode("", true)
                    ])
                  ]),
                  (_ctx.show_cancel)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        _cache[27] || (_cache[27] = _createElementVNode("p", null, "Are you sure you want to cancel the training session?", -1)),
                        _createElementVNode("button", {
                          class: "btn btn-lg btn-secondary w-100 mb-2",
                          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args)))
                        }, "Cancel Training Session"),
                        _createElementVNode("button", {
                          class: "btn btn-lg btn-secondary w-100 mb-4",
                          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showCancelConfirm && _ctx.showCancelConfirm(...args)))
                        }, "Return to Training Session Overview")
                      ]))
                    : (_ctx.show_reschedule)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                          _cache[30] || (_cache[30] = _createElementVNode("p", null, "Select convenient times for your training session", -1)),
                          _createVNode(_component_schedule_form, {
                            field: "training_session_date",
                            "alt-field": "",
                            "start-date": _ctx.start_date,
                            onUpdateDate: _ctx.setDate,
                            is_single: true
                          }, null, 8, ["start-date", "onUpdateDate"]),
                          _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("div", _hoisted_21, [
                              (_ctx.reschedule_error)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(_ctx.reschedule_error), 1))
                                : _createCommentVNode("", true),
                              _createElementVNode("button", {
                                class: "btn btn-lg btn-secondary w-100 mb-2",
                                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.showRescheduleModal && _ctx.showRescheduleModal(...args)))
                              }, "Reschedule Training Session"),
                              _createElementVNode("button", {
                                class: "btn btn-lg btn-secondary w-100 mb-4",
                                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.showReschedule && _ctx.showReschedule(...args)))
                              }, "Return to Training Session Overview")
                            ])
                          ]),
                          _createVNode(_component_modal, {
                            modelValue: _ctx.reschedule_modal,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.reschedule_modal) = $event))
                          }, {
                            header: _withCtx(() => _cache[28] || (_cache[28] = [
                              _createTextVNode("Reschedule Training Session")
                            ])),
                            default: _withCtx(() => [
                              _cache[29] || (_cache[29] = _createElementVNode("p", null, "Are you sure you want to reschedule this training session?", -1)),
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-lg btn-primary w-100 mb-2",
                                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.rescheduleTrainingSession && _ctx.rescheduleTrainingSession(...args)))
                              }, "Reschedule Training Session")
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]))
                      : (_ctx.show_edit_job_number)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                            _cache[31] || (_cache[31] = _createElementVNode("p", null, [
                              _createElementVNode("label", { for: "job_number_edit" }, "Edit Job#")
                            ], -1)),
                            _createElementVNode("div", _hoisted_24, [
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.job_number_field) = $event)),
                                name: "job_number_edit",
                                id: "job_number_edit",
                                type: "text",
                                maxlength: "255"
                              }, null, 512), [
                                [_vModelText, _ctx.job_number_field]
                              ])
                            ]),
                            (_ctx.job_number_error != '')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(_ctx.job_number_error), 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("button", {
                              class: "btn btn-lg btn-secondary w-100 mb-2",
                              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.updateJobNumber && _ctx.updateJobNumber(...args)))
                            }, "Submit Job#"),
                            _createElementVNode("button", {
                              class: "btn btn-lg btn-secondary w-100 mb-4",
                              onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.showEditJobNumber && _ctx.showEditJobNumber(...args)))
                            }, "Return to Training Session Overview")
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_26, [
                            (_ctx.is_trainer || _ctx.is_participant)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                  _createVNode(_component_join_links, {
                                    class: "d-inline",
                                    joinevent: _ctx.training_session,
                                    label: 'Training Session',
                                    user: _ctx.user
                                  }, null, 8, ["joinevent", "user"])
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.is_trainer && _ctx.training_session.is_complete == 0 && _ctx.training_session.is_canceled == 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                  _createElementVNode("button", {
                                    class: "btn btn-secondary-alt btn-md w-100 mb-2",
                                    onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.showReschedule && _ctx.showReschedule(...args)))
                                  }, "Reschedule"),
                                  _createElementVNode("button", {
                                    class: "btn btn-secondary-alt btn-md w-100 mb-2",
                                    onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.showCancelConfirm && _ctx.showCancelConfirm(...args)))
                                  }, "Cancel")
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.training_session.scenario !== null)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                  _createElementVNode("button", {
                                    class: "btn btn-secondary-alt btn-md w-100 mb-2",
                                    onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.printScenario && _ctx.printScenario(...args)))
                                  }, "Print Scenario")
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.is_trainer)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                  (_ctx.training_session.job_number !== null)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_31, [
                                        _createElementVNode("small", null, "Job# " + _toDisplayString(_ctx.training_session.job_number), 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("button", {
                                    class: "btn btn-secondary-alt btn-md w-100 mb-2",
                                    onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.showEditJobNumber && _ctx.showEditJobNumber(...args)))
                                  }, [
                                    (_ctx.training_session.job_number !== null)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_32, "Edit Job#"))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_33, "Provide Job#"))
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.training_session.scenario !== null && _ctx.training_session.is_complete == 0 && _ctx.training_session.is_canceled == 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                  _cache[32] || (_cache[32] = _createElementVNode("h4", { class: "text-center" }, "Practice Tools", -1)),
                                  _createElementVNode("button", {
                                    class: "btn btn-secondary btn-md w-100 mb-2",
                                    onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.shareScenario && _ctx.shareScenario(...args)))
                                  }, "Share Learner Information"),
                                  (_ctx.training_session.scenario.is_feedback_form_enabled)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        class: "btn btn-secondary btn-md w-100 mb-2",
                                        onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.showFeedback && _ctx.showFeedback(...args)))
                                      }, "SP Scorecard"))
                                    : _createCommentVNode("", true),
                                  (_ctx.has_verbal_feedback)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 1,
                                        class: "btn btn-secondary btn-md w-100 mb-2",
                                        onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.printFeedback && _ctx.printFeedback(...args)))
                                      }, "Print Verbal Feedback"))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("button", {
                                    class: "btn btn-secondary btn-md w-100 mb-2",
                                    onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.shareZoomMessage && _ctx.shareZoomMessage(...args)))
                                  }, "Share Stay On Zoom Message")
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.has_recording && _ctx.training_session.is_complete == 1 && (_ctx.is_trainer || _ctx.is_participant))
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 5,
                                  class: "btn btn-secondary btn-md w-100 mb-2",
                                  href: _ctx.recording_url,
                                  target: "_blank"
                                }, "View Recording", 8, _hoisted_35))
                              : (!_ctx.has_recording && _ctx.training_session.is_complete == 1 && (_ctx.is_trainer || _ctx.is_participant))
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 6,
                                    class: "btn btn-secondary btn-md w-100 mb-2",
                                    onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.recordingError && _ctx.recordingError(...args)))
                                  }, "View Recording"))
                                : _createCommentVNode("", true),
                            ((_ctx.is_trainer || _ctx.is_participant) && _ctx.training_session.is_complete == 0 && _ctx.training_session.is_canceled == 0)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_36, "If join link does not open try disabling browser's popup blocker"))
                              : _createCommentVNode("", true)
                          ])),
                  _createElementVNode("div", _hoisted_37, [
                    _cache[34] || (_cache[34] = _createElementVNode("p", { class: "text-secondary" }, [
                      _createElementVNode("strong", null, "Trainer")
                    ], -1)),
                    _createElementVNode("p", _hoisted_38, _toDisplayString(_ctx.training_session.trainer.name), 1),
                    _createElementVNode("p", _hoisted_39, [
                      _createElementVNode("small", _hoisted_40, _toDisplayString(_ctx.training_session.trainer.email), 1)
                    ]),
                    (!_ctx.is_participant)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                          _cache[33] || (_cache[33] = _createElementVNode("p", { class: "text-secondary" }, [
                            _createElementVNode("strong", null, "Participants")
                          ], -1)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.training_session.sp_users, (participant) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: participant.id
                            }, [
                              _createElementVNode("p", _hoisted_42, _toDisplayString(participant.user.name), 1),
                              _createElementVNode("p", null, [
                                _createElementVNode("small", _hoisted_43, _toDisplayString(participant.user.email), 1)
                              ])
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.is_trainer && !_ctx.training_session.is_complete)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                        (!_ctx.show_edit_participants)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "btn btn-secondary-alt btn-md w-100 mb-2",
                              onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.showEditParticipants && _ctx.showEditParticipants(...args)))
                            }, "Edit Participants"))
                          : _createCommentVNode("", true),
                        (_ctx.show_edit_participants)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                              _cache[44] || (_cache[44] = _createElementVNode("h4", { class: "mt-0 pt-0 mb-4" }, "Remove Participants", -1)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.training_session.sp_users, (participant) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: participant.id
                                }, [
                                  _createElementVNode("p", _hoisted_46, _toDisplayString(participant.user.name), 1),
                                  _createElementVNode("p", null, [
                                    _createElementVNode("small", _hoisted_47, _toDisplayString(participant.user.email), 1)
                                  ]),
                                  _createElementVNode("button", {
                                    class: "btn btn-primary btn-md",
                                    onClick: ($event: any) => (_ctx.removeUser(participant.id))
                                  }, "Remove", 8, _hoisted_48),
                                  _cache[35] || (_cache[35] = _createElementVNode("hr", null, null, -1))
                                ]))
                              }), 128)),
                              _cache[45] || (_cache[45] = _createElementVNode("h4", null, "Add Participants", -1)),
                              _createElementVNode("div", null, [
                                _cache[42] || (_cache[42] = _createElementVNode("h4", null, "Select user(s)", -1)),
                                _createElementVNode("div", _hoisted_49, [
                                  (_ctx.available_users.length)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.available_users, (ts_user) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            key: ts_user.id
                                          }, [
                                            _createElementVNode("label", _hoisted_51, [
                                              _withDirectives(_createElementVNode("input", {
                                                type: "checkbox",
                                                value: ts_user.user_id,
                                                class: "float-start me-2",
                                                width: "20",
                                                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.training_users) = $event)),
                                                onChange: _cache[20] || (_cache[20] = ($event: any) => (_ctx.has_user_error = false))
                                              }, null, 40, _hoisted_52), [
                                                [_vModelCheckbox, _ctx.training_users]
                                              ]),
                                              _cache[39] || (_cache[39] = _createElementVNode("span", { class: "check-icon" }, [
                                                _createElementVNode("i", { class: "fas fa-check" })
                                              ], -1)),
                                              _cache[40] || (_cache[40] = _createElementVNode("span", { class: "checkmark" }, null, -1)),
                                              _createElementVNode("div", _hoisted_53, [
                                                _createElementVNode("img", {
                                                  src: !ts_user.user.image ? '/img/no_image.jpg' : ts_user.user.image ,
                                                  class: "rounded-circle float-end",
                                                  width: "60"
                                                }, null, 8, _hoisted_54),
                                                _createElementVNode("span", null, _toDisplayString(ts_user.user.first_name) + " " + _toDisplayString(ts_user.user.last_name), 1),
                                                _cache[36] || (_cache[36] = _createElementVNode("br", null, null, -1)),
                                                _createElementVNode("small", null, _toDisplayString(ts_user.user.email), 1),
                                                _cache[37] || (_cache[37] = _createElementVNode("br", null, null, -1)),
                                                (ts_user.role_id == _ctx.UserRole.SP)
                                                  ? (_openBlock(), _createElementBlock("small", _hoisted_55, "Standardized Patient"))
                                                  : _createCommentVNode("", true),
                                                (ts_user.role_id == _ctx.UserRole.OBSERVER)
                                                  ? (_openBlock(), _createElementBlock("small", _hoisted_56, "Observer"))
                                                  : _createCommentVNode("", true),
                                                (ts_user.role_id == _ctx.UserRole.TRAINER)
                                                  ? (_openBlock(), _createElementBlock("small", _hoisted_57, "Trainer"))
                                                  : _createCommentVNode("", true),
                                                _cache[38] || (_cache[38] = _createElementVNode("hr", { class: "w-75 text-center" }, null, -1))
                                              ])
                                            ])
                                          ]))
                                        }), 128))
                                      ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_58, _cache[41] || (_cache[41] = [
                                        _createElementVNode("p", { class: "p-4" }, "No users available for training sessions.", -1)
                                      ])))
                                ]),
                                (_ctx.has_user_error)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_59, "You must set users"))
                                  : _createCommentVNode("", true),
                                _createElementVNode("button", {
                                  class: "btn btn-secondary-alt btn-md w-100 mt-4 mb-2",
                                  onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.addUsers && _ctx.addUsers(...args)))
                                }, "Add Users"),
                                _cache[43] || (_cache[43] = _createElementVNode("hr", { class: "w-75 text-center" }, null, -1))
                              ]),
                              _createElementVNode("button", {
                                class: "btn btn-secondary-alt btn-md w-100 mb-2",
                                onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.showEditParticipants && _ctx.showEditParticipants(...args)))
                              }, "Return to Training Session Details")
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_60, [
                  (_ctx.training_session.scenario !== null)
                    ? (_openBlock(), _createBlock(_component_scenario_card, {
                        key: 0,
                        scenario: _ctx.training_session.scenario,
                        formatted_field_data: _ctx.formatted_field_data
                      }, null, 8, ["scenario", "formatted_field_data"]))
                    : (_openBlock(), _createBlock(_component_training_card, {
                        key: 1,
                        training_session: _ctx.training_session
                      }, null, 8, ["training_session"]))
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.loading && typeof(_ctx.training_session) === 'undefined')
      ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
          _cache[46] || (_cache[46] = _createElementVNode("h4", null, "Error Loading Training Session", -1)),
          _createElementVNode("p", null, _toDisplayString(_ctx.loadErrorMessage), 1)
        ]))
      : _createCommentVNode("", true),
    _cache[47] || (_cache[47] = _createElementVNode("br", null, null, -1)),
    _createVNode(_component_loading, {
      active: _ctx.loading,
      "is-full-page": true
    }, null, 8, ["active"])
  ], 64))
}